// extracted by mini-css-extract-plugin
export default {"tags":"Tags_tags__7t6Sr","tag":"Tags_tag__lkpBl"};